import { Injectable } from '@angular/core';
import { Store, StoreConfig } from '@datorama/akita';
import { iStoreActions } from '../../core/store-actions.interface';
import { FeeSummary } from '../../../closing-cost-worksheet-15/models/ccw.models';

function createInitialState(): FeeSummary {
  return <FeeSummary>{};
}

@Injectable({ providedIn: 'root' })
@StoreConfig({ name: 'cmg-ccw-fee-summary-store' })
export class CmgCcwFeeSummaryStore extends Store<FeeSummary> implements iStoreActions<FeeSummary> {
  private _initValue: FeeSummary = null;
  constructor() {
    super(createInitialState());
  }

  preInitialize(feeSummary: FeeSummary): void {
    this.update(feeSummary);
    this._initValue = JSON.parse(JSON.stringify(this.getValue()));
  }

  get initialValue() {
    return this._initValue;
  }
}
